import { Quote } from "lucide-react";
import { ICON_STROKE } from "~/lib/icon";

export interface SelectionToolbarProps {
  left: number;
  top: number;
  flipped?: boolean;
  onQuote: () => void;
}

export function SelectionToolbar({ left, top, flipped = false, onQuote }: SelectionToolbarProps) {
  return (
    <div
      role="toolbar"
      aria-label="Selection actions"
      style={{
        position: "absolute",
        left,
        top,
        transform: flipped ? "translate(-50%, 0)" : "translate(-50%, -100%)",
        height: "var(--chat-composer-toolbar-height)",
        display: "inline-flex",
        alignItems: "center",
        padding: "0 var(--chat-space-1)",
        borderRadius: "var(--chat-radius-md)",
        border: "1px solid var(--chat-surface-raised)",
        background: "var(--chat-surface-overlay)",
        boxShadow: "var(--chat-shadow-popover)",
        zIndex: 3,
        transition: "opacity var(--chat-motion-fast) var(--chat-motion-ease)",
      }}
    >
      <button
        type="button"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onQuote}
        className="chat-button"
        style={{
          height: "var(--chat-dialog-close-size)",
          display: "inline-flex",
          alignItems: "center",
          gap: "var(--chat-space-1)",
          border: "none",
          borderRadius: "var(--chat-radius-sm)",
          background: "transparent",
          color: "var(--chat-fg-secondary)",
          fontFamily: "var(--chat-font-sans)",
          fontSize: "var(--chat-type-body-sm-size)",
          lineHeight: "var(--chat-type-body-sm-line)",
          cursor: "pointer",
          padding: "0 var(--chat-space-2)",
        }}
      >
        <Quote size={14} strokeWidth={ICON_STROKE} />
        Quote selection
      </button>
    </div>
  );
}
